import { render, staticRenderFns } from "./AssertionReasonPrivew.vue?vue&type=template&id=42b671ae&"
import script from "./AssertionReasonPrivew.vue?vue&type=script&lang=js&"
export * from "./AssertionReasonPrivew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports